export const participantConstants = {
    PARTICIPANT_ADDED_REQUEST:'PARTICIPANT_ADDED_REQUEST',
    PARTICIPANT_ADDED_SUCCESS:'PARTICIPANT_ADDED_SUCCESS',
    PARTICIPANT_ADDED_FAILURE:'PARTICIPANT_ADDED_FAILURE',

    PARTICIPANT_BY_ID_REQUEST:'PARTICIPANT_BY_ID_REQUEST',
    PARTICIPANT_BY_ID_SUCCESS:'PARTICIPANT_BY_ID_SUCCESS',
    PARTICIPANT_BY_ID_FAILURE:'PARTICIPANT_BY_ID_FAILURE',

    PARTICIPANT_LIST_REQUEST:'PARTICIPANT_LIST_REQUEST',
    PARTICIPANT_LIST_SUCCESS:'PARTICIPANT_LIST_SUCCESS',
    PARTICIPANT_LIST_ERROR:'PARTICIPANT_LIST_ERROR',

    UPDATE_PARTICIPANT_REQUEST:'UPDATE_PARTICIPANT_REQUEST',
    UPDATE_PARTICIPANT_SUCCESS:'UPDATE_PARTICIPANT_SUCCESS',
    UPDATE_PARTICIPANT_FAILURE:'UPDATE_PARTICIPANT_FAILURE',

    DELETE_PARTICIPANT_REQUEST:'DELETE_PARTICIPANT_REQUEST',
    DELETE_PARTICIPANT_SUCCESS:'DELETE_PARTICIPANT_SUCCESS',
    DELETE_PARTICIPANT_FAILURE:'DELETE_PARTICIPANT_FAILURE'
    
};